<div *ngIf="!schedule" class="container" [ngClass]="{ selected: selected }" (click)="onClick()">
  <span class="button">
    {{ label | translate }}
  </span>
</div>

<div *ngIf="schedule && label.start !== label.end" class="schedule-container">
  <span class="schedule-day">
    {{ daysOfWeek[indexSchedule] }}
  </span>
  <div>
    <span> {{ label.start }}</span>
    <span> - </span>
    <span> {{ label.end }}</span>
  </div>
</div>
